import React, {useContext,useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { Visible, Hidden } from 'components/Grid';


import Hero from './components/Hero';
import Benefits from './components/Benefits';
import TextBanner from './components/TextBanner';
import MobileFeatures from './components/Features';
import DesktopFeatures from '../Features';
import Wave from './components/Wave';
import Footer from './components/Footer';
import AmplitudeContext from './../../contexts/AmplitudeContext';

import AMPLITUDE from './../../constants/amplitude';

import {
  Scaffold,
} from './styles';

const Landing = () => {
  const { t } = useTranslation();
  const amplitude = useContext(AmplitudeContext);

  useEffect(() => {
    amplitude.logEvent(
      AMPLITUDE.EVENTS.PUBLIC_USER_LANDING, {
      SOURCE: 'RAPPI_TRAVEL_B2B_WEB',
      HOST: window.location.hostname
    });

  }, [amplitude]);
  

  return (
    <Scaffold>
      <Hero />
      <Benefits />
      <TextBanner>{t('TEXT_BANNER')}</TextBanner>
      <Visible xs sm md>
        <MobileFeatures />
      </Visible>
      <Hidden xs sm md>
        <DesktopFeatures />
      </Hidden>
      <Wave />
      <Hero isCompacted />
      <Footer />
    </Scaffold>
  );
};

export default Landing;
